import { arrayOf, bool, func, object } from "prop-types";
import { useXlsImporterSettings } from "@tools";
import { Dialog } from "@components";
import { StepsFactory, ImporterActions, ImporterStepper } from "./components";
import classnames from "classnames";

export const XlsImporter = ({
  modalOpened,
  useBufferHoursAdjustOption,
  buffersUsed,
  onImportCancel,
  onImportFinish,
}) => {
  const settings = useXlsImporterSettings({ buffersUsed });
  
  const cancelImport = () => {
    onImportCancel();
    settings.resetXlsImportToDefaults();
  }

  const finishImporting = async () => {
    onImportFinish(
      settings.xlsFileName,
      settings.importedStructure,
      settings.usedWorkTypes
    );
    settings.resetXlsImportToDefaults();
  };

  return (
    <Dialog
      fullActionPaddings
      open={modalOpened}
      onClose={cancelImport}
      useCloseButton={false}
      containerClass={classnames(
        settings.activeStep > 1 && "py-3",
        settings.activeStep === 3 && "scrollbar-visible",
        settings.activeStep === 4 && "px-12 bg-primary"
      )}
      actionsAlignment="spaceBetween"
      width={1400}
      minWidth={600}
      title={<ImporterStepper />}
      
      actions={
        <ImporterActions
          cancelImport={cancelImport}
          finishImporting={finishImporting}
          useBufferHoursAdjustOption={useBufferHoursAdjustOption}
        />
      }
    >
      <StepsFactory activeStep={settings.activeStep} />
    </Dialog>
  );
}

XlsImporter.propTypes = {
  modalOpened: bool.isRequired,
  onImportCancel: func.isRequired,
  onImportFinish: func.isRequired,
  defaultWorkTypes: arrayOf(object),
  
  useBufferHoursAdjustOption: bool,
  buffersUsed: bool,
};
